import React, { FC } from 'react';
import styled from 'styled-components';

import { DropdownMenu } from 'src/presentation/components/agent_desktop_components';
import Dropdown from 'src/presentation/components/forms/Dropdown';
import { H4 } from '@ad-scripts/presentation/components/common/headers';
import { Row, FilledContainer } from 'src/presentation/components/forms/Layout';

interface RuleEditorSectionProps {
  title: string;
}

const RuleEditorSection: FC<RuleEditorSectionProps> = function ({ children, title }) {
  return (
    <FilledContainer>
      <BoldTitle>{title}</BoldTitle>
      {children}
    </FilledContainer>
  );
};

interface AddRuleRequirementButtonProps {
  'data-aid'?: string;
  onClick: Function;
  text: string;
}

export const AddRuleRequirementButton: FC<AddRuleRequirementButtonProps> = function ({
  'data-aid': dataAid = null,
  text,
  onClick,
}) {
  return (
    <StyledAddText data-aid={dataAid} onClick={onClick}>
      ＋ {text}
    </StyledAddText>
  );
};

const BoldTitle = styled(H4)`
  font-weight: bolder;
`;

const StyledAddText = styled.div`
  color: ${p => p.theme.colors.green400};
  cursor: pointer;
`;

export const StyledDropdown = styled(Dropdown)`
  ${DropdownMenu} {
    margin-left: 12px;
    width: 230px;
  }
`;

export const StyledSelectorRow = styled(Row)`
  align-items: center;
  display: flex;
`;

export default RuleEditorSection;
